export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          投稿爆料<i className="ri-mail-send-line text-primary-500 ml-2"></i>
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">你有料 · 我敢发</p>

        <div className="mt-8 max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70 text-center">
            <div className="w-16 h-16 mx-auto rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-add-line text-2xl text-primary-500"></i>
            </div>
            <h3 className="mt-5 text-lg font-heading font-bold text-foreground-900">
              欢迎投稿 · 有偿爆料
            </h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-md mx-auto">
              如果你掌握娱乐圈、网红圈或社交平台的第一手黑料，欢迎向我们投稿。爆料一经采用，将给予丰厚稿酬。所有投稿信息严格保密，保护爆料人隐私安全。
            </p>
            <div className="mt-5 flex flex-col sm:flex-row items-center justify-center gap-3">
              <div className="flex items-center gap-2 text-sm text-foreground-700 bg-background-100 px-4 py-2.5 rounded-lg">
                <i className="ri-mail-line text-primary-500"></i>
                <span>baoliao@91heilia.com</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700 bg-background-100 px-4 py-2.5 rounded-lg">
                <i className="ri-wechat-line text-primary-500"></i>
                <span>91黑料官方</span>
              </div>
            </div>
            <p className="mt-4 text-xs text-foreground-500">
              投稿即表示同意本站内容发布规则，本站保留审核与修改权利。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}